// @flow
import * as React from 'react';
import { ImagePickerField } from 'components/Form';

const LogoPickerField = ({
  name,
  label,
  description,
  centerButton,
  overlayButton,
  confirmModal,
  onChange,
  message,
  size,
  ...props
}: {
  name: string,
  label?: string,
  message?: string,
  description?: string,
  centerButton?: boolean,
  overlayButton?: boolean,
  confirmModal?: Object,
  onChange?: Function,
  size?: number
}) => (
  <ImagePickerField
    previewWidth={size || 128}
    previewHeight={size || 128}
    format="logo"
    message={message || getText('Drag a logo here')}
    name={name}
    label={label}
    description={description}
    centerButton={centerButton}
    overlayButton={overlayButton}
    confirmModal={confirmModal}
    onChange={onChange}
    {...props}
  />
);

export default LogoPickerField;
